import React from "react";
import { Link } from "react-router-dom";
import styles from "./IssueTable.module.css";

const IssueTable = ({ title, data, emptyMessage = "No issues available" }) => {
  const hasData = Array.isArray(data) && data.length > 0;

  return (
    <div className={styles.wrapper}>
      <h4 className={styles.title}>{title}</h4>

      <table className={styles.table}>
  <colgroup>
    <col className={styles.colRef} />
    <col className={styles.colTitle} />
    <col className={styles.colIssue} />
    <col className={styles.colDate} />
    <col className={styles.colDate} />
  </colgroup>

  <thead>
    <tr>
      <th>Reference No.</th>
      <th>Title</th>
      <th>Issue</th>
      <th>Publication Date</th>
      <th>Withdrawal Date</th>
    </tr>
  </thead>

  <tbody>
    {hasData ? (
      data.map((item, index) => (
        <tr key={index}>
          <td>{item.ref}</td>
          <td className={styles.ellipsis}>
            {item.standardId ? (
              <Link
                to={`/document/${item.standardId}`}
                className={styles.titleLink}
              >
                {item.title}
              </Link>
            ) : (
              item.title
            )}
          </td>
          <td>
            <span className={styles.history}>{item.issue || "-"}</span>
          </td>
          <td>{item.publicationDate || "-"}</td>
          <td>{item.endDate || "-"}</td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={5} className={styles.empty}>
          {emptyMessage}
        </td>
      </tr>
    )}
  </tbody>
</table>

    </div>
  );
};

export default IssueTable;
